import { render } from "./ModeratorRating.vue?vue&type=template&id=5f04a366&scoped=true"
import script from "./ModeratorRating.vue?vue&type=script&lang=js"
export * from "./ModeratorRating.vue?vue&type=script&lang=js"

import "./ModeratorRating.vue?vue&type=style&index=0&id=5f04a366&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f04a366"]])

export default __exports__